import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { ProgressBarMode } from "../Global/Progressbar";

@ModuleName("ToCheckout")
export class ToCheckout implements AxInit {
    constructor(private _requestHelper = new RequestHelper()) { }

    initData: ToCheckoutInitData;

    AxInit(init: ToCheckoutInitData): void {
        this.initData = init;
        AxessViewer.loadPartialView('/ShoppingCart/Checkout', init.formData, (result) => {

            if (result.success) {
                if (this.initData.processIndicatorActive) {
                    result.successLink = this._requestHelper.insertParam(result.successLink, "ref", this.initData.progressBarMode == ProgressBarMode.Suballotment ? "pit" : "pi");
                }
                window.location.href = result.successLink;
            }
            else {
                if (typeof result.redirect != 'undefined') {
                    window.location.href = result.redirect;
                }

                let errors = JSON.parse(result.errors);
                this._requestHelper.postToUrl(this.initData.shoppingCartUrl, errors);
            }
        }, {});
    }
}

interface ToCheckoutInitData {
    formData: any;
    shoppingCartUrl: string;
    processIndicatorActive: boolean;
    progressBarMode: ProgressBarMode;
}